export default __webpack_public_path__ + "static/media/Bears.f665c50d.jpg";